<script setup lang="ts">
import {NotificationTemplate} from "@/notification-template/interfaces";
import {computed} from "vue";
import SMSNotificationTemplate from "@/notification-template/components/SMSNotificationTemplate.vue";
import PushNotificationTemplate from "@/notification-template/components/PushNotificationTemplate.vue";
import BaseButton from "@/core/components/base/BaseButton.vue";
import RCSNotificationTemplate from "@/notification-template/components/RCSNotificationTemplate.vue";
import NotificationTemplateService from "@/notification-template/services/NotificationTemplateService";

const {template, selectable, selectLabel = "Sélectionner", buttonPrimary = true, showName = true} = defineProps<{
    template: NotificationTemplate;
    selectable?: boolean;
    selectLabel?: string;
    buttonPrimary?: boolean;
    showName?: boolean;
}>();

defineEmits<{
    (e: 'selected', template: NotificationTemplate): void
}>();

const templateComponent = computed(() => {
    switch (template.type) {
        case 'sms':
            return SMSNotificationTemplate;
        case 'notification':
            return PushNotificationTemplate;
        case "rcs":
        case "rcs_flow":
            return RCSNotificationTemplate;
        default:
            return null;
    }
});

const hasCost = computed(() => {
    return ['sms', 'rcs', 'rcs_flow'].includes(template.type) && template.credits > 0;
});
</script>

<template>
  <div class="space-y-3">
    <p v-if="showName" :class="{'text-center': NotificationTemplateService.isRcsType(template)}">
      {{ template.name }}
    </p>
    <div
      class="flex items-center gap-x-4 gap-y-1" :class="{
        'flex-col': NotificationTemplateService.isRcsType(template) && selectable
      }"
    >
      <component :is="templateComponent" class="flex-1" :v-if="templateComponent" :template="template" />
      <slot name="before-select-button" />
      <div v-if="selectable" class="flex flex-col gap-1 items-center">
        <BaseButton :primary="buttonPrimary" @click="$emit('selected', template)">
          {{ selectLabel }}
        </BaseButton>
        <div v-if="hasCost" class="text-primary text-sm">
          {{ template.credits }} {{ $filters.pluralize('crédit', template.credits) }}
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
